function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1-1h36v36H-1z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#9CA6B0",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11 12v15h12V12m-8 10v-6m4 6v-6M9 9h16M14 6h6"
}));
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34
  }, props), _ref);
}
export default SvgTrash;